import React from "react";
import styles from "componets/button/loading.module.scss";

const LoadingIcon = () => {

  return(
    <div className={styles["lds-ellipsis"]}>
      <div/>
      <div/>
      <div/>
      <div/>
    </div>
  )
};


export default LoadingIcon
